import axios from 'axios'
import store from '@state/store'
import toast from './request-message'
import formatErrorMessage from './format-response-message'

axios.defaults.baseURL = '/api';

axios.interceptors.request.use(
  (config) => {
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
);

axios.interceptors.response.use((response) => {
  return response.data && (response.data.data || response.data)
}, errorResponseHandler);

function errorResponseHandler(error) {

  // check fro errorHandle config
  const { config, response } = error;
  if (response) {
    if (config.hasOwnProperty('customErrorHandle')) {
      config.customErrorHandle(response.data)
      return Promise.reject(response.data);
    }

    // axios v0.19.0 custom config 會被忽略
    if (config.hasOwnProperty('errorHandle') && config.errorHandle === false) {
      return response.data
      // return  Promise.reject(response.data);
    }

    toast.error(formatErrorMessage(response.data.status));

    // 405 Method Not Allowed
    if(response.data.code === 405 || response.data.code === 401) {
      store.dispatch('auth/logOut');

      window.location = `/login?redirectFrom=${location.pathname}`;
    }

    return Promise.reject(response.data)
  } else if (!window.navigator.onLine) {
    toast.error('網路出了點問題，請重新連線後刷新頁面')
  } else {
    return Promise.reject(error)
  }
}

export default axios
